import React, { useState } from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export default function Prize() {
    const { t } = useTranslation();
    const PrizeData = t("prize", { returnObjects: true });
    const maxIndex = PrizeData.length - 1;
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? maxIndex : prevIndex - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex === maxIndex ? 0 : prevIndex + 1));
    };

    const generateSuperlatives = (number) => {
        if (number === 1) {
            return "st";
        } else if (number === 2) {
            return "nd";
        } else if (number === 3) {
            return "rd";
        } else {
            return "th";
        }
    }

    return (
        <div className="bg-white relative">
            <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("prizeTitle")} />
            </div>
            <div className="flex mx-auto items-center justify-center z-10 min-h-screen md:pt-10 py-12 md:py-24 bg-no-repeat bg-cover bg-top w-full bg-bgPrizePage md:max-lg:px-8">
                <div className="px-8 2xl:px-0 md:px-14 w-full pb-4 md:pt-48">
                    <div className="w-full font-poppins text-[#164481]">
                        <div className="max-md:hidden grid grid-cols-2 gap-x-4 lg:gap-x-12">
                            <div className="font-poppins flex flex-wrap justify-center w-[360px] place-self-end self-baseline">
                                <div clasName="basis-full w-full">
                                    <p className="bg-white relative top-6 text-[#164481] border-2 px-4 py-2 border-[#164481] text-3xl">{PrizeData[0].category}</p>
                                </div>
                                <div className="basis-full p-8 bg-[#164481] text-white grid grid-cols-1 gap-y-2 pt-12">
                                    {PrizeData[0].data.map((prize) => {
                                        return (
                                            <div className="flex justify-start">
                                                <div className="basis-full font-poppins"><span className="font-bold">{prize.id}</span><span className="align-top text-sm">{generateSuperlatives(prize.id)}</span> Place  </div>
                                                <div className="basis-full font-poppins"><span className="font-bold">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(
                                                    prize.prize,
                                                )}</span></div>
                                            </div>);
                                    })}
                                </div>
                            </div>
                            <div className="font-poppins grid grid-cols-1 justify-center place-self-start">
                                <div className="w-[360px] grid grid-cols-1">
                                    <div className="w-fit place-self-center">
                                        <p className="bg-white w-fit relative top-6 text-[#164481] text-center border-2 px-4 py-2 border-[#164481] text-3xl">{PrizeData[1].category}</p>
                                    </div>
                                    <div className="basis-full p-8 bg-[#24aae5] text-white grid grid-cols-1 gap-y-2 pt-12">
                                        {PrizeData[1].data.map((prize) => {
                                            return (
                                                <div className="flex justify-start">
                                                    <div className="basis-full font-poppins"><span className="font-bold">{prize.id}</span><span className="align-top text-sm">{generateSuperlatives(prize.id)}</span> Place  </div>
                                                    <div className="basis-full font-poppins"><span className="font-bold">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(
                                                        prize.prize,
                                                    )}</span></div>
                                                </div>);
                                        })}
                                    </div>
                                </div>
                                <div className="w-[360px] grid grid-cols-1">
                                    <div className="w-fit place-self-center">
                                        <p className="bg-white w-fit relative top-6 text-[#164481] text-center border-2 px-4 py-2 border-[#164481] text-3xl">{PrizeData[2].category}</p>
                                    </div>
                                    <div className="basis-full p-8 bg-[#efc91a] text-[#164481] grid grid-cols-1 gap-y-2 pt-12">
                                        {PrizeData[2].data.map((prize) => {
                                            return (
                                                <div className="flex justify-start">
                                                    <div className="basis-full font-poppins"><span className="font-bold">{prize.id}</span><span className="align-top text-sm">{generateSuperlatives(prize.id)}</span> Place  </div>
                                                    <div className="basis-full font-poppins"><span className="font-bold">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(
                                                        prize.prize,
                                                    )}</span></div>
                                                </div>);
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:hidden grid grid-cols-2 gap-x-12">
                            <div className="font-poppins grid grid-cols-1 justify-center place-self-start">
                                <div className="w-[360px] grid grid-cols-1">
                                    <div className="w-fit place-self-center">
                                        <p className="bg-white w-fit relative top-6 text-[#164481] text-center border-2 px-4 py-2 border-[#164481] text-3xl">{PrizeData[0].category}</p>
                                    </div>
                                    <div className="basis-full p-8 bg-[#164481] text-white grid grid-cols-1 gap-y-2 pt-12">
                                        {PrizeData[0].data.map((prize) => {
                                            return (
                                                <div className="flex justify-start">
                                                    <div className="basis-full font-poppins"><span className="font-bold">{prize.id}</span><span className="align-top text-sm">{generateSuperlatives(prize.id)}</span> Place  </div>
                                                    <div className="basis-full font-poppins"><span className="font-bold">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(
                                                        prize.prize,
                                                    )}</span></div>
                                                </div>);
                                        })}
                                    </div>
                                </div>
                                <div className="w-[360px] grid grid-cols-1">
                                    <div className="w-fit place-self-center">
                                        <p className="bg-white w-fit relative top-6 text-[#164481] text-center border-2 px-4 py-2 border-[#164481] text-3xl">{PrizeData[1].category}</p>
                                    </div>
                                    <div className="basis-full p-8 bg-[#24aae5] text-white grid grid-cols-1 gap-y-2 pt-12">
                                        {PrizeData[1].data.map((prize) => {
                                            return (
                                                <div className="flex justify-start">
                                                    <div className="basis-full font-poppins"><span className="font-bold">{prize.id}</span><span className="align-top text-sm">{generateSuperlatives(prize.id)}</span> Place  </div>
                                                    <div className="basis-full font-poppins"><span className="font-bold">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(
                                                        prize.prize,
                                                    )}</span></div>
                                                </div>);
                                        })}
                                    </div>
                                </div>
                                <div className="w-[360px] grid grid-cols-1">
                                    <div className="w-fit place-self-center">
                                        <p className="bg-white w-fit relative top-6 text-[#164481] text-center border-2 px-4 py-2 border-[#164481] text-3xl">{PrizeData[2].category}</p>
                                    </div>
                                    <div className="basis-full p-8 bg-[#efc91a] text-[#164481] grid grid-cols-1 gap-y-2 pt-12">
                                        {PrizeData[2].data.map((prize) => {
                                            return (
                                                <div className="flex justify-start">
                                                    <div className="basis-full font-poppins"><span className="font-bold">{prize.id}</span><span className="align-top text-sm">{generateSuperlatives(prize.id)}</span> Place  </div>
                                                    <div className="basis-full font-poppins"><span className="font-bold">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(
                                                        prize.prize,
                                                    )}</span></div>
                                                </div>);
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="h-full"> */}
            {/* </div> */}
        </div>
    );
}
